import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { platformStats, faqData } from '@/mocks/articles';

export default function AboutPage() {
  const stats = [
    { value: platformStats.totalArticles.toLocaleString(), label: '累计爆料文章', icon: 'ri-article-line' },
    { value: (platformStats.dailyReaders / 10000).toFixed(0) + '万', label: '日均读者', icon: 'ri-user-line' },
    { value: (platformStats.avgDailyPageviews / 10000).toFixed(0) + '万', label: '日均浏览', icon: 'ri-eye-line' },
    { value: platformStats.activeContributors + '+', label: '活跃爆料人', icon: 'ri-team-line' },
  ];

  return (
    <>
      <Navbar />

      <main className="pt-16">
        {/* Hero */}
        <section className="relative py-16 md:py-24 px-4 md:px-6 overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20warm%20dramatic%20artistic%20background%20with%20soft%20gradient%2C%20minimalist%20editorial%20style%2C%20cream%20and%20gold%20tones%2C%20subtle%20texture%2C%20cinematic%20mood%2C%20elegant%20composition%2C%20warm%20atmosphere%2C%20modern%20abstract%20art&width=1800&height=800&seq=about-hero-bg&orientation=landscape"
              alt=""
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/50"></div>
          </div>
          <div className="relative z-10 max-w-3xl mx-auto text-center">
            <h1 className="text-3xl md:text-5xl font-heading text-white mb-5">关于今日吃瓜</h1>
            <p className="text-base md:text-lg text-white/80 leading-relaxed max-w-2xl mx-auto">
              中国领先的娱乐八卦新闻聚合平台，致力于为吃瓜群众提供最新、最全、最热门的网红爆料、娱乐圈内幕、直播翻车现场等实时资讯。
            </p>
          </div>
        </section>

        {/* Brand Story */}
        <section className="py-12 md:py-16 px-4 md:px-6">
          <div className="max-w-4xl mx-auto">
            <div className="flex flex-col lg:flex-row gap-10 items-center">
              <div className="lg:w-2/5">
                <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20editorial%20office%20abstract%20scene%2C%20warm%20dramatic%20lighting%2C%20minimalist%20artistic%20composition%2C%20cream%20and%20gold%20tones%2C%20editorial%20photography%20style%2C%20soft%20shadows%2C%20elegant%20atmosphere%2C%20warm%20ambient%20light&width=800&height=600&seq=about-office&orientation=landscape"
                    alt="今日吃瓜编辑部"
                    title="今日吃瓜编辑部"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <div className="lg:w-3/5">
                <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-5">品牌故事</h2>
                <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
                  <p>
                    <strong>今日吃瓜</strong>创立于2023年，总部位于北京市朝阳区望京SOHO。作为国内领先的娱乐八卦资讯聚合平台，我们专注于为用户提供及时、全面、有趣的吃瓜内容。
                  </p>
                  <p>
                    平台名称"今日吃瓜"源自网络流行语"吃瓜群众"，寓意"今天的瓜今天吃，新鲜热乎不隔夜"。我们坚持"真实第一、速度至上"的运营理念，24小时不间断追踪全网热点。
                  </p>
                  <p>
                    经过三年发展，今日吃瓜已汇聚了超过150位活跃爆料人，日均发布独家爆料内容超过50篇，逐渐成为中文互联网最受欢迎的吃瓜资讯平台之一。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Platform Data */}
        <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2 text-center">平台数据</h2>
            <p className="text-sm text-foreground-500 mb-10 text-center">我们用数据说话，以下数据实时更新</p>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
              {stats.map((stat) => (
                <div
                  key={stat.label}
                  className="rounded-xl bg-background-50 p-6 md:p-8 text-center"
                >
                  <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100">
                    <i className={`${stat.icon} text-primary-600 text-lg`}></i>
                  </div>
                  <div className="text-2xl md:text-3xl font-heading text-foreground-900 mb-1">{stat.value}</div>
                  <div className="text-xs text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>

            {/* Monthly Report */}
            <div className="mt-10 rounded-2xl bg-background-50 p-8 md:p-10">
              <h3 className="text-lg font-heading text-foreground-900 mb-6">月度数据报告</h3>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
                <div>
                  <div className="text-xs text-foreground-500 mb-1">月均投稿数</div>
                  <div className="text-xl font-heading text-foreground-900">{platformStats.monthlyReports.toLocaleString()}</div>
                </div>
                <div>
                  <div className="text-xs text-foreground-500 mb-1">内容分类数</div>
                  <div className="text-xl font-heading text-foreground-900">{platformStats.totalCategories}</div>
                </div>
                <div>
                  <div className="text-xs text-foreground-500 mb-1">累计文章数</div>
                  <div className="text-xl font-heading text-foreground-900">{platformStats.totalArticles.toLocaleString()}</div>
                </div>
                <div>
                  <div className="text-xs text-foreground-500 mb-1">活跃爆料人</div>
                  <div className="text-xl font-heading text-foreground-900">{platformStats.activeContributors}+</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Business Cooperation */}
        <section className="py-12 md:py-16 px-4 md:px-6">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2 text-center">商务合作</h2>
            <p className="text-sm text-foreground-500 mb-10 text-center">欢迎各大品牌、媒体机构与我们合作洽谈</p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              <div className="rounded-xl bg-background-100 p-6 md:p-8 text-center">
                <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-500">
                  <i className="ri-advertisement-line text-background-50 text-xl"></i>
                </div>
                <h3 className="text-base font-medium text-foreground-900 mb-2">广告投放</h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-4">
                  提供品牌广告、软文植入、原生广告等多种投放形式，精准触达千万级吃瓜用户。
                </p>
                <p className="text-xs text-foreground-400">
                  <i className="ri-mail-line mr-1"></i>bd@jinrichigua.com
                </p>
              </div>

              <div className="rounded-xl bg-background-100 p-6 md:p-8 text-center">
                <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-accent-500">
                  <i className="ri-shake-hands-line text-background-50 text-xl"></i>
                </div>
                <h3 className="text-base font-medium text-foreground-900 mb-2">内容合作</h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-4">
                  欢迎媒体机构及内容创作者入驻，共享流量收益，共同打造优质吃瓜内容生态。
                </p>
                <p className="text-xs text-foreground-400">
                  <i className="ri-mail-line mr-1"></i>content@jinrichigua.com
                </p>
              </div>

              <div className="rounded-xl bg-background-100 p-6 md:p-8 text-center">
                <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-secondary-500">
                  <i className="ri-briefcase-line text-background-50 text-xl"></i>
                </div>
                <h3 className="text-base font-medium text-foreground-900 mb-2">商务总机</h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-4">
                  周一至周五 9:00-18:00，我们的商务团队将竭诚为您服务。
                </p>
                <p className="text-xs text-foreground-400">
                  <i className="ri-phone-line mr-1"></i>400-888-6666 转 3
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Info */}
        <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2 text-center">联系我们</h2>
            <p className="text-sm text-foreground-500 mb-10 text-center">吃瓜热线24小时在线，欢迎爆料投稿与商务咨询</p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              <div className="rounded-xl bg-background-50 p-6 md:p-8">
                <h3 className="text-base font-medium text-foreground-900 mb-4">公司信息</h3>
                <div className="space-y-3 text-sm text-foreground-600">
                  <p className="flex items-start gap-3">
                    <i className="ri-building-line text-foreground-400 mt-0.5"></i>
                    <span>北京吃瓜互娱科技有限公司</span>
                  </p>
                  <p className="flex items-start gap-3">
                    <i className="ri-map-pin-line text-foreground-400 mt-0.5"></i>
                    <span>北京市朝阳区望京SOHO T1 B座 18层 1808室</span>
                  </p>
                  <p className="flex items-start gap-3">
                    <i className="ri-phone-line text-foreground-400 mt-0.5"></i>
                    <span>400-888-6666</span>
                  </p>
                  <p className="flex items-start gap-3">
                    <i className="ri-mail-line text-foreground-400 mt-0.5"></i>
                    <span>tips@jinrichigua.com</span>
                  </p>
                </div>
              </div>

              <div className="rounded-xl bg-background-50 p-6 md:p-8">
                <h3 className="text-base font-medium text-foreground-900 mb-4">社交媒体</h3>
                <div className="space-y-4">
                  <a href="#" className="flex items-center gap-3 p-3 rounded-lg bg-background-100 hover:bg-background-200 transition-colors cursor-pointer border-b border-transparent">
                    <div className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-100">
                      <i className="ri-weibo-line text-primary-600"></i>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-900">微博</div>
                      <div className="text-xs text-foreground-500">@今日吃瓜官方</div>
                    </div>
                  </a>
                  <a href="#" className="flex items-center gap-3 p-3 rounded-lg bg-background-100 hover:bg-background-200 transition-colors cursor-pointer border-b border-transparent">
                    <div className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-100">
                      <i className="ri-wechat-line text-accent-600"></i>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-900">微信公众号</div>
                      <div className="text-xs text-foreground-500">今日吃瓜官方号</div>
                    </div>
                  </a>
                  <a href="#" className="flex items-center gap-3 p-3 rounded-lg bg-background-100 hover:bg-background-200 transition-colors cursor-pointer border-b border-transparent">
                    <div className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-100">
                      <i className="ri-tiktok-line text-secondary-600"></i>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-900">抖音</div>
                      <div className="text-xs text-foreground-500">今日吃瓜官方号</div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-12 md:py-16 px-4 md:px-6">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2 text-center">常见问题</h2>
            <p className="text-sm text-foreground-500 mb-10 text-center">关于今日吃瓜的常见疑问解答</p>

            <div className="space-y-3">
              {faqData.map((faq, idx) => (
                <details key={idx} className="group rounded-xl bg-background-100 border border-background-200 overflow-hidden">
                  <summary className="flex items-center justify-between p-5 cursor-pointer hover:bg-background-200 transition-colors">
                    <span className="text-sm font-medium text-foreground-900 pr-4">{faq.question}</span>
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform flex-shrink-0"></i>
                  </summary>
                  <div className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">有猛料要爆料？</h2>
            <p className="text-sm text-foreground-500 mb-6">
              今日吃瓜平台设有爆料奖励机制，根据爆料的独家性和重要性，
              提供50元至5000元不等的信息费奖励。
            </p>
            <div className="flex items-center justify-center gap-4 flex-wrap">
              <a
                href="mailto:tips@jinrichigua.com"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-send-line"></i>
                发送爆料邮件
              </a>
              <Link
                to="/"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-foreground-900 text-background-50 text-sm font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-arrow-left-line"></i>
                返回首页
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />

      {/* Schema.org Structured Data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于今日吃瓜 - 品牌介绍与商务合作',
            url: 'https://www.jinrichigua.com/about',
            description: '今日吃瓜品牌介绍、平台数据、商务合作联系信息。中国领先的娱乐八卦新闻聚合平台。',
            isPartOf: {
              '@type': 'WebSite',
              name: '今日吃瓜',
              url: 'https://www.jinrichigua.com/',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '今日吃瓜',
            legalName: '北京吃瓜互娱科技有限公司',
            url: 'https://www.jinrichigua.com/',
            description: '中国领先的娱乐八卦新闻聚合平台',
            address: {
              '@type': 'PostalAddress',
              streetAddress: '望京SOHO T1 B座 18层 1808室',
              addressLocality: '北京',
              addressRegion: '朝阳区',
              addressCountry: 'CN',
            },
            contactPoint: [
              {
                '@type': 'ContactPoint',
                telephone: '400-888-6666',
                contactType: 'customer service',
                email: 'tips@jinrichigua.com',
              },
              {
                '@type': 'ContactPoint',
                telephone: '400-888-6666 转 3',
                contactType: 'business cooperation',
                email: 'bd@jinrichigua.com',
              },
            ],
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: '首页',
                item: 'https://www.jinrichigua.com/',
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: '关于我们',
                item: 'https://www.jinrichigua.com/about',
              },
            ],
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqData.map((faq) => ({
              '@type': 'Question',
              name: faq.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.answer,
              },
            })),
          }),
        }}
      />
    </>
  );
}